"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChannelVideoById = exports.listChannelVideos = exports.parseChannelVideoResponse = exports.parseListChannelResponse = exports.ctx = exports.service = exports.createService = void 0;
var tslib_1 = require("tslib");
var channel_videos_1 = require("@wix/wix-vod-api-site-based/dist/src/public/services/channel-videos/channel-videos");
var to_error_1 = require("../../parsers/to-error");
var video_item_1 = require("../../parsers/video-item");
var context_1 = require("@wix/wix-vod-shared/dist/src/common/utils/context");
exports.createService = function () { return new channel_videos_1.PublicChannelVideos(); };
exports.service = exports.createService();
exports.ctx = context_1.createCtx(exports.service);
exports.parseListChannelResponse = function (response, sort) { return (tslib_1.__assign(tslib_1.__assign({}, response), { data: _.map(response.data.items, video_item_1.parseVideoItem), sort: sort, paging: {
        size: response.data.items.length,
        cursor: response.data.cursor,
    } })); };
exports.parseChannelVideoResponse = function (response) { return (tslib_1.__assign(tslib_1.__assign({}, response), { data: video_item_1.parseVideoItem(response.data) })); };
exports.listChannelVideos = function (_a) {
    var channelId = _a.channelId, query = _a.query, tag = _a.tag, category = _a.category, mediaType = _a.mediaType, sort = _a.sort, paging = _a.paging, hydratedChannelVideos = _a.hydratedChannelVideos, templateMetaSiteId = _a.templateMetaSiteId;
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var response, _b, error_1;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    _b = hydratedChannelVideos;
                    if (_b) return [3 /*break*/, 2];
                    return [4 /*yield*/, exports.service.getList({
                            channelId: channelId,
                            query: query,
                            tag: tag,
                            category: category,
                            mediaType: mediaType,
                            sort: sort,
                            paging: paging,
                            templateMetaSiteId: templateMetaSiteId,
                        })];
                case 1:
                    _b = (_c.sent());
                    _c.label = 2;
                case 2:
                    response = _b;
                    return [2 /*return*/, exports.parseListChannelResponse(response, sort)];
                case 3:
                    error_1 = _c.sent();
                    return [2 /*return*/, to_error_1.toError(error_1)];
                case 4: return [2 /*return*/];
            }
        });
    });
};
exports.getChannelVideoById = function (channelId, videoId, _a) {
    var _b = _a === void 0 ? {} : _a, hydratedVideo = _b.hydratedVideo, templateMetaSiteId = _b.templateMetaSiteId;
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var response, _c, error_2;
        return tslib_1.__generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 3, , 4]);
                    _c = hydratedVideo;
                    if (_c) return [3 /*break*/, 2];
                    return [4 /*yield*/, exports.service.getChannelVideoById(channelId, videoId, {
                            params: {
                                metaSiteId: templateMetaSiteId,
                            },
                        })];
                case 1:
                    _c = (_d.sent());
                    _d.label = 2;
                case 2:
                    response = _c;
                    return [2 /*return*/, exports.parseChannelVideoResponse(response)];
                case 3:
                    error_2 = _d.sent();
                    return [2 /*return*/, to_error_1.toError(error_2)];
                case 4: return [2 /*return*/];
            }
        });
    });
};
//# sourceMappingURL=channel-videos.js.map